<template>
  <div :id="id" :style="{ height: resolveHeight, width: resolveWidth }"></div>
  <teleport to="#app">
    <DashboardSeeMoreModal
      :is-open="isDashboardSeeMoreModalOpen"
      :day="heatmapSelectedFullDay"
      :selectedChannel="(chartLineSelectedSeeMoreChannel as ChannelType)"
      :selected-day="heatmapSelectedDay"
      :selected-hour-range="heatmapSelectedHourRange"
      :start-date-time="subStartDateTime"
      :end-date-time="subEndDateTime"
      :has-date-filter="'true'"
      @hide="closeDashboardSeeMoreModal"
    />
  </teleport>
</template>

<script setup lang="ts">
import useBarWithLineChart from './hooks/useBarWithLineChart';
import DashboardSeeMoreModal from '@/views/modules/analytics/components/anal-churnrate/chart-churn-rate/chart-modal/DashboardSeeMoreModal.vue';

type ChannelType = 1 | 2 | 3 | 4; // 1=sms 2=email 3=line 4=mobile-push

interface Props {
  rawData?: Charts.ChartsProps.RawData;
  colorList: Charts.ChartsProps.ColorItem[];
  height?: number | string;
  width?: number | string;
  responsiveWidth?: boolean;
  responsiveHeight?: boolean;
  eventType?: string;
  function?: Function;
}

const props = withDefaults(defineProps<Props>(), {
  options: undefined,
  height: 200,
  width: 300,
  responsiveWidth: false,
  responsiveHeight: false,
  eventType: 'dbClick' || '',
  function: () => {},
});

const {
  id,
  resolveHeight,
  resolveWidth,
  isDashboardSeeMoreModalOpen,
  heatmapSelectedFullDay,
  chartLineSelectedSeeMoreChannel,
  heatmapSelectedDay,
  heatmapSelectedHourRange,
  subStartDateTime,
  subEndDateTime,
} = useBarWithLineChart(props);

function closeDashboardSeeMoreModal() {
  isDashboardSeeMoreModalOpen.value = false;
}
</script>

<style lang="scss">
$width-tooltip: 5rem;
$color-tooltip: #0277ff;
.line-tooltip {
  background-color: #fff;
  pointer-events: auto;

  .line-tooltip-button-container {
    position: relative;
    background-color: #fff;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    opacity: 0.3;
    pointer-events: none;

    &:hover {
      transition: 0.25s;
      background-color: #e5f1ff;
    }
    &:hover .tooltiptext {
      transition: 0.25s;
      visibility: visible;
    }

    .tooltiptext {
      visibility: hidden;
      width: $width-tooltip;
      background-color: $color-tooltip;
      opacity: 0.8;
      color: #fff;
      text-align: center;
      border-radius: 3px;
      padding: 5px;
      top: -35px;
      /* Position the tooltip */
      position: absolute;
      z-index: 2;
    }
    .tooltiptext::after {
      content: '';
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid $color-tooltip;
      bottom: -5px;
      left: 45%;
      position: absolute;
      z-index: 1;
    }
  }
}
</style>
